<template>
  <div class="text-left px-6 pb-12 bg-gray-50 h-screen">
    <div class="absolute mt-11" @click="back">
      <back-arrow-icon :width="'w-4'" :height="'h-4'"></back-arrow-icon>
    </div>
    <div class="text-center text-sm font-extrabold w-full pt-12">DELIVERY HISTORY</div>
    <no-history></no-history>
    <past-orders></past-orders>
  </div>
</template>

<script>
import BackArrowIcon from '@/components/icons/BackArrowIcon.vue'
import NoHistory from '../components/History/NoHistory.vue'
import PastOrders from '../components/History/PastOrders.vue'
export default {
  components: {
    BackArrowIcon,
    NoHistory,
    PastOrders
  },
  data() {
    return {
      promo_code: '',
      payment_type: {
        pick_up: false,
        delivery: false,
        card: false
      }
    }
  },
  methods: {
    back() {
      this.$router.push({
        name: 'Dashboard'
      })
    }
  }
}
</script>

<style></style>
